module.exports = __webpack_public_path__ + "static/img/1introduce.dd19dd1e.jpg";